import { render, staticRenderFns } from "./CompanyAssetEmails.vue?vue&type=template&id=cf16fbd8"
import script from "./CompanyAssetEmails.vue?vue&type=script&lang=js"
export * from "./CompanyAssetEmails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf16fbd8')) {
      api.createRecord('cf16fbd8', component.options)
    } else {
      api.reload('cf16fbd8', component.options)
    }
    module.hot.accept("./CompanyAssetEmails.vue?vue&type=template&id=cf16fbd8", function () {
      api.rerender('cf16fbd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/companysetting/assets/CompanyAssetEmails.vue"
export default component.exports